import { css } from 'styled-components';

export const SURVEY_FILTER_OPEN = 'opened';
export const SURVEY_FILTER_CLOSED = 'closed';
export const CARD_WIDTH = 312;
export const surveyCardVariants = {
	carouselCard: css`
		width: ${CARD_WIDTH}px;
	`,
	listCard: css`
		width: 100%;
	`
};
